export const lang_translate = [];
lang_translate["الرجاء تأكد انك ادخلت جميع الخانات قبل التسجيل"]= "Please make sure that you have entered all the fields before registering";
lang_translate["الرجاء ادخال كلمة المرور"]= "Please enter the password";
lang_translate["رقم واحد على الأقل"]= "At least one number";
  
  export default {
    lang_translate,
  }